Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageContentParser
  constructor: ->
    @instagramMessageParser = new Models.Parsers.InstagramMessageParser
    @authorParser = new Models.Parsers.InstagramUserParser

  canHandle: (data) ->
    data.sub_type == 'ig-message' && data.origin == 'instagram-message-api'

  parse: (data) ->
    message = @instagramMessageParser.parse(data.message)
    author = @authorParser.parse(data.author)
    isBrandContent = data.is_brand_content
    createdAt = data.created_at
    brandId = data.message.id
    origin = data.origin
    parentId = data.parent_id
    new Models.InstagramMessageContent(message, author, isBrandContent, brandId, origin, parentId)
